import { render } from "./TopbarOverflowMenu.vue?vue&type=template&id=5a95f122&scoped=true"
import script from "./TopbarOverflowMenu.vue?vue&type=script&lang=js"
export * from "./TopbarOverflowMenu.vue?vue&type=script&lang=js"

import "./TopbarOverflowMenu.vue?vue&type=style&index=0&id=5a95f122&scoped=true&lang=css"
import "./TopbarOverflowMenu.vue?vue&type=style&index=1&id=5a95f122&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a95f122"]])

export default __exports__